export const mockStoreData = {
  store: {
    id: 1,
    name: "فروشگاه شیک‌پوش",
    slug: "shikpoosh-store",
    template: "modern",
    logo: "/images/logo.png",

    primary_color: "#0056b3",

    banner_title: "استایل جدید خودت را پیدا کن",
    banner_text:
      "در فروشگاه شیک‌پوش مجموعه‌ای از جدیدترین پوشاک مردانه و زنانه را با بهترین قیمت پیدا کنید.",
    banner_button: "مشاهده فروشگاه",
    banner_link: "/store",

    banner_image:
      "https://dkstatics-public.digikala.com/digikala-admin-landing/466ca6f3f664a7d453672df07207575fc95cb9f4_1653387158.jpg",
  },

  home_banners: {
    first_row: [
      {
        image:
          "https://dkstatics-public.digikala.com/digikala-admin-landing/1573c10d2feef51495d49668b9d1e465c58757a8_1773839258.jpg?x-oss-process=image/format,webp",
        link: "/store?category=mens-clothing",
      },
      {
        image:
          "https://dkstatics-public.digikala.com/digikala-adservice-banners/8a2436e9b5fd318025ba25314bbe5b826aebb731_1778311314.jpg?x-oss-process=image/quality,q_95/format,webp",
        link: "/store?category=womens-clothing",
      },
      {
        image:
          "https://dkstatics-public.digikala.com/digikala-adservice-banners/590a1742e244165b7d4d5eda0b831e21c4b425dd_1778303778.jpg?x-oss-process=image/quality,q_95/format,webp",
        link: "/products?discount=true",
      },
    ],

    second_row: [
      {
        image:
          "https://dkstatics-public.digikala.com/digikala-adservice-banners/b846b692942a1c89ad2a2e7c478a2162783029fb_1777478729.jpg?x-oss-process=image/quality,q_95/format,webp",
        link: "/store",
      },
      {
        image:
          "https://dkstatics-public.digikala.com/digikala-adservice-banners/7c395ad81054044ecd731ce3dfac5a2eb97eba06_1777976785.jpg?x-oss-process=image/quality,q_95/format,webp",
        link: "/products",
      },
      {
        image:
          "https://dkstatics-public.digikala.com/digikala-adservice-banners/7c395ad81054044ecd731ce3dfac5a2eb97eba06_1777976785.jpg?x-oss-process=image/quality,q_95/format,webp",
        link: "/about",
      },
    ],
  },
  categories: [
    { id: 1, name: "لباس مردانه", parent_id: null, slug: "mens-clothing" },
    { id: 2, name: "پیراهن مردانه", parent_id: 1, slug: "mens-shirts" },
    { id: 3, name: "شلوار مردانه", parent_id: 1, slug: "mens-pants" },
    { id: 4, name: "لباس زنانه", parent_id: null, slug: "womens-clothing" },
    { id: 5, name: "مانتو زنانه", parent_id: 4, slug: "womens-mantos" },
    { id: 6, name: "شال و روسری", parent_id: 4, slug: "womens-scarves" },
    { id: 7, name: " لباس مجلسی ", parent_id: 4, slug: "womens-scarves" },
    { id: 8, name: " لباس اداری ", parent_id: 4, slug: "womens-scarves" },

    { id: 9, name: "کفش زنانه", parent_id: null, slug: "womens-clothing" },
    { id: 10, name: "کفش مردانه", parent_id: null, slug: "womens-clothing" },
  ],

  sections: [
    {
      page_key: "home",
      section_key: "hero",
      section_type: "slider",
      content: {
        slides: [
          {
            title: "جدیدترین کالکشن بهاره",
            subtitle: "با طرح‌های جذاب و منحصربه‌فرد",
            image:
              "https://dkstatics-public.digikala.com/digikala-adservice-banners/590a1742e244165b7d4d5eda0b831e21c4b425dd_1778303778.jpg?x-oss-process=image/quality,q_95/format,webp",
            cta_text: "مشاهده محصولات",
            cta_link: "/products",
          },
          {
            title: "تخفیف ویژه",
            subtitle: "تا 50٪ تخفیف",
            image:
              "https://dkstatics-public.digikala.com/digikala-adservice-banners/b846b692942a1c89ad2a2e7c478a2162783029fb_1777478729.jpg?x-oss-process=image/quality,q_95/format,webp",
            cta_text: "مشاهده تخفیف‌ها",
            cta_link: "/products?discount=true",
          },
        ],
      },
    },

    {
      page_key: "home",
      section_key: "featured_products",
      section_type: "product_list",
      content: { title: "محصولات ویژه", products: [] },
    },

    {
      page_key: "home",
      section_key: "new_products",
      section_type: "product_list",
      content: { title: "جدیدترین محصولات", products: [] },
    },

    {
      page_key: "home",
      section_key: "discounted_products",
      section_type: "product_list",
      content: { title: "فروش ویژه", products: [] },
    },

    // {
    //   page_key: "home",
    //   section_key: "categories",
    //   section_type: "category_grid",
    //   content: { title: "دسته بندی‌ها" },
    // },

    {
      page_key: "home",
      section_key: "about_us_preview",
      section_type: "text_image",
      content: {
        title: "درباره فروشگاه ما",
        description:
          "در شیک‌پوشان تلاش کرده‌ایم تجربه‌ای متفاوت از خرید پوشاک را برای شما فراهم کنیم. ما با دقت در انتخاب محصولات، جدیدترین ترندهای دنیای مد و پوشاک را گردآوری کرده‌ایم تا بتوانید با خیال راحت و سلیقه‌ای خاص، استایل دلخواه خود را بسازید. کیفیت، زیبایی و رضایت مشتری سه اصل مهم در شیک‌پوشان است و هدف ما این است که هر خرید برای شما تجربه‌ای لذت‌بخش و مطمئن باشد.",
        image:
          "https://dkstatics-public.digikala.com/digikala-admin-landing/466ca6f3f664a7d453672df07207575fc95cb9f4_1653387158.jpg",
        cta_text: "بیشتر بدانید",
        cta_link: "/about",
      },
    },
  ],

  products: [
    {
      id: 1,
      name: "پیراهن مردانه کلاسیک",
      slug: "classic-mens-shirt",
      price: 1200000,
      old_price: 1500000,
      discount_percent: 20,
      availability: "موجود",
      image:
        "https://dkstatics-public.digikala.com/digikala-products/9956d7e7c95fe9e949fba9583d89ab9db4575fa2_1771364693.jpg?x-oss-process=image/resize,m_lfit,h_300,w_300/format,webp/quality,q_80",
      attributes: ["جنس: پنبه", "سایز: L"],
      category_id: 2,
    },

    {
      id: 2,
      name: "پیراهن مردانه چهارخانه",
      slug: "checkered-mens-shirt",
      price: 1350000,
      availability: "موجود",
      image:
        "https://dkstatics-public.digikala.com/digikala-products/ca2d966fef7a3991017bd549bdb015d793e6aadb_1759949261.jpg?x-oss-process=image/resize,m_lfit,h_300,w_300/format,webp/quality,q_80",
      attributes: ["جنس: نخ", "سایز: XL"],
      category_id: 2,
      description: "تست متن پاراگراف",
    },

    {
      id: 3,
      name: "شلوار جین آبی",
      slug: "blue-jeans",
      price: 1800000,
      availability: "موجود",
      image:
        "https://www.digikala.com/mag/wp-content/uploads/2026/02/Crop-coat-model9-610x380.jpg",
      attributes: ["جنس: جین", "رنگ: آبی"],
      category_id: 3,
    },

    {
      id: 4,
      name: "مانتو زنانه مجلسی",
      slug: "elegant-manto",
      price: 2500000,
      availability: "موجود",
      image:
        "https://www.digikala.com/mag/wp-content/uploads/2026/02/Skirt-jacket-model-for-Eid19-610x380.jpg",
      attributes: ["رنگ: مشکی", "سایز: فری"],
      category_id: 5,
    },

    {
      id: 5,
      name: "تیشرت اسپرت مردانه",
      slug: "sport-tshirt",
      price: 600000,
      availability: "موجود",
      image:
        "https://dkstatics-public.digikala.com/digikala-products/112334599.jpg",
      attributes: ["جنس: نخ پنبه", "رنگ: سفید"],
      category_id: 2,
    },

    {
      id: 6,
      name: "شال نخی گلدار",
      slug: "flower-scarf",
      price: 450000,
      availability: "موجود",
      image:
        "https://www.digikala.com/mag/wp-content/uploads/2025/12/Guipure-evening-dress-model-7-610x380.png",
      attributes: ["طرح: گلدار", "جنس: نخ"],
      category_id: 6,
    },

    {
      id: 7,
      name: "پلیور زمستانه مردانه",
      slug: "winter-sweater",
      price: 1900000,
      availability: "موجود",
      image:
        "https://www.digikala.com/mag/wp-content/uploads/2025/12/Classic-style-for-girls-14-610x380.webp",
      attributes: ["جنس: پشم", "رنگ: سرمه‌ای"],
      category_id: 1,
    },
  ],

  pages: {
    about: {
      title: "درباره فروشگاه ما",
      content:
        "در بخش مدیریت سایت قسمت درباره ما می‌توانید عنوان و این متن را اضافه کنید.",
      image:
        "https://www.digikala.com/mag/wp-content/uploads/2026/02/Ice-hair-color435-610x380.jpg",
    },

    contact: {
      title: "تماس با ما",
      address: "تهران، خیابان ولیعصر",
      phone: "02112345678",
      // email: "info@shikpoosh.com",
    },
  },

  footer_sections: [
    {
      section_key: "footer_social_links",
      items: [
        {
          content_json: {
            platform: "instagram",
            url: "https://instagram.com/demo-shop",
          },
        },
        {
          content_json: {
            platform: "telegram",
            url: "https://t.me/demo-shop",
          },
        },
        {
          content_json: {
            platform: "twitter",
            url: "https://twitter.com/demo-shop",
          },
        },
        {
          content_json: {
            platform: "Whatsapp",
            url: "https://twitter.com/demo-shop",
          },
        },
      ],
    },
  ],
};

const allProducts = mockStoreData.products;

mockStoreData.sections.find(
  (s) => s.section_key === "featured_products",
).content.products = allProducts.filter((p) => [1, 2, 3, 4].includes(p.id));

mockStoreData.sections.find(
  (s) => s.section_key === "new_products",
).content.products = allProducts.filter((p) => [4, 5, 6, 2].includes(p.id));

mockStoreData.sections.find(
  (s) => s.section_key === "discounted_products",
).content.products = allProducts.filter((p) => [1, 2, 3, 4].includes(p.id));

export { allProducts };
